export default __webpack_public_path__ + "static/media/colour_color_1.36b41278.png";